document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.lang;
  const t = (lang === 'en')
    ? { qty: 'Choose quantity:', freq: 'Choose frequency:', dosage: 'Choose dosage:' }
    : { qty: 'Wybierz ilość:', freq: 'Wybierz częstotliwość:', dosage: 'Wybierz dawkę:' };

  function getUnitText() {
    const tags = window.svProductTags || [];
    if (tags.includes('zestaw')) {
      return lang === 'en' ? 'set' : 'zestaw';
    }
    if (tags.includes('has_variants_kreatyna') || tags.includes('has_variants_bialko')) {
      return lang === 'en' ? 'box' : 'pudełko';
    }
    if (tags.includes('has_variants_platki')) {
      return lang === 'en' ? 'jar' : 'słoik';
    }
    return lang === 'en' ? 'jar' : 'słoiczek';
  }
  const unitText = getUnitText();
  let refreshPrices = null;
  let refreshFromVariant = null;

  function checkElement() {
    if (document.querySelector('.rc_widget__option__plans__dropdown.rc-selling-plans__dropdown')) {
      clearInterval(interval);
      setTimeout(init, 300);
    }
  }
  const interval = setInterval(checkElement, 200);

  function init() {
    cloneButtons();
    cloneSubscriptionElements();
    buildSubControlsRow();
    buildOneControlsRow();
    cloneInfoTexts();
    createDosageRadios();
    // Inicjalizacja mnożenia ceny po załadowaniu cen z Recharge
    setTimeout(initPriceMultiplication, 800);
  }

  // Klonuje przyciski add-to-cart do sekcji sub i onetime
  function cloneButtons() {
    const original = document.querySelector('.product-form__buttons');
    if (!original) return;

    const subLabel = document.querySelector('.rc_widget__option--subsave label');
    if (subLabel) {
      const clone = original.cloneNode(true);
      clone.classList.add('sv-add-to-cart-sub');
      subLabel.insertAdjacentElement('afterend', clone);
    }

    const oneLabel = document.querySelector('.rc_widget__option--onetime label');
    if (oneLabel) {
      const clone = original.cloneNode(true);
      clone.classList.add('sv-add-to-cart-one');
      const btn = clone.querySelector('button[name="add"]');
      if (btn) btn.disabled = false;
      oneLabel.insertAdjacentElement('afterend', clone);
    }
  }

  // Klonuje bloki korzyści subskrypcji (bullet points)
  function cloneSubscriptionElements() {
    const subEls = document.querySelectorAll('.product__subscription');
    const atcSub = document.querySelector('.sv-add-to-cart-sub');
    if (subEls.length && atcSub) {
      const wrapper = document.createElement('div');
      wrapper.className = 'sv-subscription-elements';
      subEls.forEach(el => {
        const clone = el.cloneNode(true);
        clone.classList.add('copy');
        wrapper.appendChild(clone);
      });
      atcSub.insertAdjacentElement('beforebegin', wrapper);
    }

    const oneEls = document.querySelectorAll('.product__subscription--single-purchase');
    const atcOne = document.querySelector('.sv-add-to-cart-one');
    if (oneEls.length && atcOne) {
      const wrapper = document.createElement('div');
      // Używamy tej samej klasy co stara logika — dzięki temu zielony box
      // "A może jednak subskrypcja?" zdefiniowany w liquid CSS działa automatycznie
      wrapper.className = 'onetime-elements-wrapper';
      oneEls.forEach(el => {
        const clone = el.cloneNode(true);
        clone.classList.add('copy');
        wrapper.appendChild(clone);
      });
      atcOne.insertAdjacentElement('beforebegin', wrapper);
    }
  }

  // Buduje wiersz ilość + częstotliwość dla subskrypcji
  function buildSubControlsRow() {
    const qtyEl = document.querySelector('.product-form__quantity');
    const freqDropdown = document.querySelector('.rc_widget__option__plans__dropdown.rc-selling-plans__dropdown');
    const atcSub = document.querySelector('.sv-add-to-cart-sub');
    if (!qtyEl || !freqDropdown || !atcSub) return;

    const clonedQty = buildQuantityControl(qtyEl, 'sv-quantity-sub');

    // Opakuj dropdown częstotliwości
    const freqWrap = document.createElement('div');
    freqWrap.className = 'sv-freq-wrap';
    freqDropdown.parentNode.insertBefore(freqWrap, freqDropdown);
    freqWrap.appendChild(freqDropdown);
    buildFreqDropdown(freqDropdown, freqWrap);

    // Zbuduj wiersz
    const row = document.createElement('div');
    row.className = 'sv-controls-row';

    const qtyCol = document.createElement('div');
    qtyCol.className = 'sv-col-qty';
    const qtyLbl = document.createElement('span');
    qtyLbl.className = 'sv-col-label';
    qtyLbl.textContent = t.qty;
    qtyCol.appendChild(qtyLbl);
    qtyCol.appendChild(clonedQty.wrapper);

    const freqCol = document.createElement('div');
    freqCol.className = 'sv-col-freq';
    const freqLbl = document.createElement('span');
    freqLbl.className = 'sv-col-label';
    freqLbl.textContent = t.freq;
    freqCol.appendChild(freqLbl);
    freqCol.appendChild(freqWrap);

    row.appendChild(qtyCol);
    row.appendChild(freqCol);
    atcSub.insertAdjacentElement('beforebegin', row);
  }

  // Buduje wrapper onetime: quantity obok przycisku kup teraz (jak w starej logice)
  function buildOneControlsRow() {
    const qtyEl = document.querySelector('.product-form__quantity');
    const atcOne = document.querySelector('.sv-add-to-cart-one');
    if (!qtyEl || !atcOne) return;

    const clonedQty = buildQuantityControl(qtyEl, 'quantity-onetime');

    // Wrapper z tą samą klasą co stara logika — quantity obok przycisku (flex row-reverse)
    const wrapper = document.createElement('div');
    wrapper.className = 'addToCart-wrapperOne';
    atcOne.parentNode.insertBefore(wrapper, atcOne);
    wrapper.appendChild(atcOne);
    wrapper.appendChild(clonedQty.wrapper);

  }

  // Buduje kontrolkę quantity od zera (bez cloneNode) — eliminuje problemy z connectedCallback i step
  function buildQuantityControl(realQtyEl, extraClass) {
    const realInput = realQtyEl.querySelector('.quantity__input');

    const wrapper = document.createElement('div');
    wrapper.className = 'product-form__quantity ' + extraClass;

    const minusBtn = document.createElement('button');
    minusBtn.className = 'quantity__button no-js-hidden';
    minusBtn.setAttribute('name', 'minus');
    minusBtn.setAttribute('type', 'button');
    minusBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 010 1H1A.5.5 0 01.5 1z" fill="currentColor"/></svg>';

    const input = document.createElement('input');
    input.className = 'quantity__input';
    input.type = 'number';
    input.name = 'quantity';
    input.min = realInput ? (realInput.min || '1') : '1';
    input.value = '1';
    input.step = '1';

    const plusBtn = document.createElement('button');
    plusBtn.className = 'quantity__button no-js-hidden';
    plusBtn.setAttribute('name', 'plus');
    plusBtn.setAttribute('type', 'button');
    plusBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/></svg>';

    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const val = parseInt(input.value) || 1;
      const min = parseInt(input.min) || 1;
      if (val > min) {
        input.value = val - 1;
        if (realInput) realInput.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
      if (realInput) realInput.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('change', () => {
      if (realInput) realInput.value = input.value;
    });

    wrapper.appendChild(minusBtn);
    wrapper.appendChild(input);
    wrapper.appendChild(plusBtn);

    return { wrapper, input };
  }

  // Klonuje statyczny tekst informacyjny pod przyciski (bez podmiany per wariant)
  function cloneInfoTexts() {
    const subInfo = document.querySelector('.product-onetime');
    const atcSub = document.querySelector('.sv-add-to-cart-sub');
    if (subInfo && atcSub) {
      const clone = subInfo.cloneNode(true);
      clone.classList.add('sv-info-text');
      atcSub.insertAdjacentElement('afterend', clone);
    }

    const oneInfo = document.querySelector('.product-onetime');
    // Celujemy w wrapper (nie w button wewnątrz niego) żeby tekst był pod wierszem, nie w nim
    const wrapperOne = document.querySelector('.addToCart-wrapperOne');
    if (oneInfo && wrapperOne) {
      const clone = oneInfo.cloneNode(true);
      clone.classList.add('sv-info-text');
      wrapperOne.insertAdjacentElement('afterend', clone);
    }
  }

  // Mnożenie ceny × ilość na przycisku ATC (sub i onetime)
  function initPriceMultiplication() {
    function getShopifyVariantPrice() {
      const el = document.querySelector('.price-item.price-item--regular');
      if (!el) return null;
      const p = parseFloat(el.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
      return isNaN(p) || p <= 0 ? null : p;
    }

    function getRechargeDiscountPct() {
      const el = document.querySelector('.rc-option__discount');
      return el ? (parseFloat(el.textContent.replace(/[^0-9,.]/g, '')) || 0) : 0;
    }

    // ONETIME
    function updateOnePrice() {
      const variantPrice = getShopifyVariantPrice();
      const qtyInput = document.querySelector('.quantity-onetime .quantity__input');
      const priceBtn = document.querySelector('.sv-add-to-cart-one .recharge-inner-most-price');
      if (!variantPrice || !priceBtn) return;
      const qty = parseInt(qtyInput?.value) || 1;
      priceBtn.textContent = (variantPrice * qty).toFixed(2) + ' zł';
    }

    // SUBSCRIPTION
    function updateSubPrice() {
      const variantPrice = getShopifyVariantPrice();
      const qtyInput = document.querySelector('.sv-quantity-sub .quantity__input');
      const priceBtn = document.querySelector('.sv-add-to-cart-sub .recharge-inner-most-price');
      if (!variantPrice || !priceBtn) return;
      const discountPct = getRechargeDiscountPct();
      const subPrice = discountPct > 0 ? variantPrice * (1 - discountPct / 100) : variantPrice;
      const qty = parseInt(qtyInput?.value) || 1;
      priceBtn.setAttribute('data-base-price', subPrice.toFixed(2));
      priceBtn.textContent = (subPrice * qty).toFixed(2) + ' zł';
    }

    // CENA PER JEDNOSTKA — wstawiana po elemencie Recharge (jak w starej logice)
    function insertUnitPrice(priceElSelector, spanClass, retries) {
      const priceEl = document.querySelector(priceElSelector);

      // Usuń poprzedni span jeśli istnieje
      const existing = document.querySelector('.' + spanClass);
      if (existing) existing.remove();

      if (!priceEl) {
        if (retries > 0) setTimeout(() => insertUnitPrice(priceElSelector, spanClass, retries - 1), 600);
        return;
      }

      const raw = priceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
      const price = parseFloat(raw);

      if (isNaN(price) || price <= 0) {
        if (retries > 0) setTimeout(() => insertUnitPrice(priceElSelector, spanClass, retries - 1), 600);
        return;
      }

      const span = document.createElement('span');
      span.className = spanClass;
      span.textContent = price.toFixed(2) + ' zł / ' + unitText;
      priceEl.insertAdjacentElement('afterend', span);
    }

    refreshPrices = function() {
      updateOnePrice();
      updateSubPrice();
      insertUnitPrice('.rc_widget__price--subsave', 'price-span', 3);
      insertUnitPrice('.rc_widget__price--onetime', 'price-span-one', 3);
    };

    // Aktualizacja cen na podstawie ceny wariantu Shopify (po zmianie dawkowania)
    // Recharge nie zawsze aktualizuje swoje elementy przy zmianie wariantu,
    // więc czytamy bezpośrednio z elementu ceny Shopify i obliczamy rabat sub
    refreshFromVariant = function() {
      const shopifyPriceEl = document.querySelector('.price-item.price-item--regular');
      if (!shopifyPriceEl) return;
      const variantPrice = parseFloat(shopifyPriceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
      if (isNaN(variantPrice) || variantPrice <= 0) return;

      const discountEl = document.querySelector('.rc-option__discount');
      const discountPct = discountEl ? (parseFloat(discountEl.textContent.replace(/[^0-9,.]/g, '')) || 0) : 0;
      const subPrice = discountPct > 0 ? variantPrice * (1 - discountPct / 100) : variantPrice;

      // ATC sub
      const subBtn = document.querySelector('.sv-add-to-cart-sub .recharge-inner-most-price');
      if (subBtn) {
        const qty = parseInt(document.querySelector('.sv-quantity-sub .quantity__input')?.value) || 1;
        subBtn.textContent = (subPrice * qty).toFixed(2) + ' zł';
        subBtn.setAttribute('data-base-price', subPrice.toFixed(2));
      }

      // ATC onetime
      const oneBtn = document.querySelector('.sv-add-to-cart-one .recharge-inner-most-price');
      if (oneBtn) {
        const qty = parseInt(document.querySelector('.quantity-onetime .quantity__input')?.value) || 1;
        oneBtn.textContent = (variantPrice * qty).toFixed(2) + ' zł';
      }

      // Span sub / jednostka
      const subPriceEl = document.querySelector('.rc_widget__price--subsave');
      if (subPriceEl) {
        const ex = document.querySelector('.price-span');
        if (ex) ex.remove();
        const span = document.createElement('span');
        span.className = 'price-span';
        span.textContent = subPrice.toFixed(2) + ' zł / ' + unitText;
        subPriceEl.insertAdjacentElement('afterend', span);
      }

      // Span onetime / jednostka
      const onePriceEl = document.querySelector('.rc_widget__price--onetime');
      if (onePriceEl) {
        const ex = document.querySelector('.price-span-one');
        if (ex) ex.remove();
        const span = document.createElement('span');
        span.className = 'price-span-one';
        span.textContent = variantPrice.toFixed(2) + ' zł / ' + unitText;
        onePriceEl.insertAdjacentElement('afterend', span);
      }
    };

    refreshPrices();
    // Dodatkowe odświeżenie z ceny Shopify — Recharge może załadować domyślny wariant,
    // podczas gdy Shopify poprawnie odzwierciedla aktualnie wybrany wariant (np. po odświeżeniu strony)
    setTimeout(refreshFromVariant, 200);

    // Nasłuchuj zmian ilości
    const qtyOne = document.querySelector('.quantity-onetime .quantity__input');
    if (qtyOne) qtyOne.addEventListener('change', updateOnePrice);

    const qtySub = document.querySelector('.sv-quantity-sub .quantity__input');
    if (qtySub) qtySub.addEventListener('change', updateSubPrice);

    // Aktualizuj cenę sub przy zmianie częstotliwości
    const freqDropdown = document.querySelector('.sv-freq-wrap .rc_widget__option__plans__dropdown');
    if (freqDropdown) {
      freqDropdown.addEventListener('change', () => setTimeout(() => {
        updateSubPrice();
        insertUnitPrice('.rc_widget__price--subsave', 'price-span', 3);
      }, 800));
    }

    // Obserwuj zmiany cen Recharge (wariant dawkowania, częstotliwość itp.)
    // — MutationObserver jest niezawodny niezależnie od czasu odpowiedzi Recharge
    (function watchRechargeprices() {
      let debounce;
      const observer = new MutationObserver(() => {
        clearTimeout(debounce);
        debounce = setTimeout(() => { if (refreshPrices) refreshPrices(); }, 300);
      });
      const config = { childList: true, subtree: true, characterData: true };
      const subPriceEl = document.querySelector('.rc_widget__price--subsave');
      const onePriceEl = document.querySelector('.rc_widget__price--onetime');
      if (subPriceEl) observer.observe(subPriceEl, config);
      if (onePriceEl) observer.observe(onePriceEl, config);
    })();

    // Pilnuj formatu ceny we WSZYSTKICH .recharge-inner-most-price —
    // zewnętrzny RC widget resetuje textContent do formatu Shopify (bez spacji) przy init i przełączaniu opcji
    (function watchAndFixPriceFormat() {
      function fixEl(el) {
        const t = el.textContent;
        const fixed = t.replace(/(\d)(zł)/g, '$1 $2');
        if (fixed !== t) el.textContent = fixed;
      }
      function fixAll() {
        document.querySelectorAll('.recharge-inner-most-price').forEach(fixEl);
      }
      const obs = new MutationObserver(fixAll);
      const root = document.querySelector('.product__info-container') || document.body;
      obs.observe(root, { childList: true, subtree: true, characterData: true });
      fixAll();
    })();
  }

  // Tworzy radio buttony dla wariantu dawki (tylko dla kreatyny: Wybierz dawkę: 3g/5g)
  function createDosageRadios() {
    const dosageSelect = document.querySelector(
      'select[name="options[Wybierz dawkę:]"], select[name="options[Select dosage:]"]'
    );
    if (!dosageSelect) return;

    const container = dosageSelect.closest('.product-form__input');
    if (!container) return;

    // Ukryj oryginalny dropdown i jego labelkę
    const selectWrap = dosageSelect.closest('.select');
    if (selectWrap) { selectWrap.style.visibility = 'hidden'; selectWrap.style.position = 'absolute'; }
    const formLabel = container.querySelector('.form__label');
    if (formLabel) { formLabel.style.visibility = 'hidden'; formLabel.style.position = 'absolute'; }

    const options = dosageSelect.querySelectorAll('option');

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-dosage-radios';

    // Nagłówki (jak w starej logice)
    const chooseDosageSpan = document.createElement('span');
    chooseDosageSpan.className = 'choose-dosage';
    chooseDosageSpan.textContent = t.dosage;
    wrapper.appendChild(chooseDosageSpan);

    const whichDosageSpan = document.createElement('span');
    whichDosageSpan.className = 'which-dosage';
    whichDosageSpan.textContent = lang === 'en' ? 'which dosage to choose?' : 'jaką dawkę wybrać?';
    wrapper.appendChild(whichDosageSpan);

    options.forEach((option, i) => {
      const optionID = `dosage-radio-${i}`;
      const radioContainer = document.createElement('div');
      radioContainer.className = 'custom-dosage-option' + (option.selected ? ' active' : '');

      const input = document.createElement('input');
      input.type = 'radio';
      input.id = optionID;
      input.name = 'custom_dosage_variant';
      input.value = option.value;
      input.checked = option.selected;
      // Accessible hiding jak w starej logice — obsługuje :checked + label::before
      input.style.position = 'absolute';
      input.style.opacity = '0';
      input.style.width = '1px';
      input.style.height = '1px';
      input.style.margin = '-1px';
      input.style.overflow = 'hidden';
      input.style.clip = 'rect(0,0,0,0)';

      const label = document.createElement('label');
      label.htmlFor = optionID;
      label.textContent = option.textContent.trim();

      input.addEventListener('change', function () {
        if (!this.checked) return;
        dosageSelect.value = option.value;
        dosageSelect.dispatchEvent(new Event('change', { bubbles: true }));
        wrapper.querySelectorAll('.custom-dosage-option').forEach(el => el.classList.remove('active'));
        radioContainer.classList.add('active');
        // Odczekaj aż Shopify zaktualizuje cenę wariantu, potem odśwież wyświetlane ceny
        // (Recharge może nie aktualizować swoich elementów przy zmianie wariantu dawki)
        setTimeout(() => { if (refreshFromVariant) refreshFromVariant(); }, 400);
      });

      radioContainer.appendChild(input);
      radioContainer.appendChild(label);
      wrapper.appendChild(radioContainer);
    });

    container.insertAdjacentElement('afterend', wrapper);

    // Modal "jaką dawkę wybrać?" — identyczny jak w starej logice
    const modalContent = {
      pl: {
        title: 'Jaką dawkę wybrać?',
        text: 'Zalecane dawkowanie kreatyny należy dostosować zarówno do masy ciała, jak i intensywności treningu.',
        close: 'Zamknij',
        headers: ['Masa ciała', 'Umiarkowana aktywność / rekreacja', 'Intensywny trening / sport wyczynowy'],
        rows: [['< 75 kg', '3g / dzień', '5g / dzień'], ['\u2265 75 kg', '5g / dzień', '5g / dzień']]
      },
      en: {
        title: 'Which dosage to choose?',
        text: 'The recommended creatine dosage should be adjusted to both body weight and training intensity.',
        close: 'Close',
        headers: ['Body weight', 'Moderate activity / recreation', 'Intense training / competitive sport'],
        rows: [['< 75 kg', '3g / day', '5g / day'], ['\u2265 75 kg', '5g / day', '5g / day']]
      }
    };
    const mc = modalContent[lang] || modalContent['en'];

    const modalHTML = `
      <div class="dosage-modal-overlay">
        <div class="dosage-modal-content">
          <button class="dosage-modal-close" aria-label="${mc.close}">&times;</button>
          <h3 class="dosage-modal-title">${mc.title}</h3>
          <p class="dosage-modal-text">${mc.text}</p>
          <table class="dosage-table desktop-table">
            <thead><tr><th>${mc.headers[0]}</th><th>${mc.headers[1]}</th><th>${mc.headers[2]}</th></tr></thead>
            <tbody>
              <tr><td>${mc.rows[0][0]}</td><td>${mc.rows[0][1]}</td><td>${mc.rows[0][2]}</td></tr>
              <tr><td>${mc.rows[1][0]}</td><td>${mc.rows[1][1]}</td><td>${mc.rows[1][2]}</td></tr>
            </tbody>
          </table>
          <div class="dosage-table-div mobile-table">
            <div class="dosage-table-div-header">
              <span style="font-size:16px;line-height:21px;font-weight:600;">${mc.headers[0]}</span>
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.rows[0][0]}</span>
            </div>
            <div class="dosage-table-div-row">
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.headers[1]}</span>
              <span style="font-size:14px;line-height:21px;font-weight:400;white-space:nowrap;">${mc.rows[0][1]}</span>
            </div>
            <div class="dosage-table-div-row">
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.headers[2]}</span>
              <span style="font-size:14px;line-height:21px;font-weight:400;white-space:nowrap;">${mc.rows[1][1]}</span>
            </div>
            <div class="dosage-table-div-header">
              <span style="font-size:16px;line-height:21px;font-weight:600;">${mc.headers[0]}</span>
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.rows[1][0]}</span>
            </div>
            <div class="dosage-table-div-row">
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.headers[1]}</span>
              <span style="font-size:14px;line-height:21px;font-weight:400;white-space:nowrap;">${mc.rows[0][2]}</span>
            </div>
            <div class="dosage-table-div-row">
              <span style="font-size:16px;line-height:21px;font-weight:400;">${mc.headers[2]}</span>
              <span style="font-size:14px;line-height:21px;font-weight:400;white-space:nowrap;">${mc.rows[1][2]}</span>
            </div>
          </div>
        </div>
      </div>`;

    function openDosageModal() {
      let modal = document.querySelector('.dosage-modal-overlay');
      if (!modal) {
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        modal = document.querySelector('.dosage-modal-overlay');
        modal.querySelector('.dosage-modal-close').addEventListener('click', closeDosageModal);
        modal.addEventListener('click', (e) => { if (e.target === modal) closeDosageModal(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDosageModal(); });
      }
      modal.style.display = 'flex';
    }

    function closeDosageModal() {
      const modal = document.querySelector('.dosage-modal-overlay');
      if (modal) modal.style.display = 'none';
    }

    whichDosageSpan.addEventListener('click', openDosageModal);
  }

  // Buduje custom dropdown dla wyboru częstotliwości
  function buildFreqDropdown(nativeSelect, container) {
    const options = Array.from(nativeSelect.options);
    if (!options.length) return;

    const dropdown = document.createElement('div');
    dropdown.className = 'custom-variant-dropdown';

    // Toggle (widoczna głowa dropdownu)
    const toggle = document.createElement('div');
    toggle.className = 'variant-dropdown-toggle';
    const toggleLabel = document.createElement('span');
    toggleLabel.className = 'variant-label';
    toggleLabel.textContent = options[nativeSelect.selectedIndex]?.text || options[0].text;
    toggle.appendChild(toggleLabel);
    toggle.appendChild(createDropdownArrow());

    // Lista opcji
    const list = document.createElement('ul');
    list.className = 'variant-dropdown-list';

    options.forEach((option, i) => {
      const item = document.createElement('li');
      item.className = 'variant-dropdown-item' + (i === nativeSelect.selectedIndex ? ' active' : '');
      const itemLabel = document.createElement('span');
      itemLabel.className = 'variant-label';
      itemLabel.textContent = option.text;
      item.appendChild(itemLabel);
      item.appendChild(createDropdownArrow());

      item.addEventListener('click', () => {
        nativeSelect.value = option.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        toggleLabel.textContent = option.text;
        list.querySelectorAll('.variant-dropdown-item').forEach(el => el.classList.remove('active'));
        item.classList.add('active');
        close();
      });

      list.appendChild(item);
    });

    function open() {
      toggle.classList.add('open');
      list.classList.add('open');
    }
    function close() {
      toggle.classList.remove('open');
      list.classList.remove('open');
    }

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      toggle.classList.contains('open') ? close() : open();
    });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) close();
    });

    dropdown.appendChild(toggle);
    dropdown.appendChild(list);
    container.appendChild(dropdown);
  }

  function createDropdownArrow() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '21');
    svg.setAttribute('viewBox', '0 0 20 21');
    svg.setAttribute('fill', 'none');
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('y', '0.346191');
    rect.setAttribute('width', '20');
    rect.setAttribute('height', '20');
    rect.setAttribute('rx', '10');
    rect.setAttribute('fill', '#244545');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5.5 8.84619L10 11.8462L14.5 8.84619');
    path.setAttribute('stroke', 'white');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(rect);
    svg.appendChild(path);
    return svg;
  }
});
